import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import ShortInfo from './../block/ShortInfo'
import Cards1 from './../block/Cards1'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import Ruchkibezopasnost from './../block/Ruchkibezopasnost'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class DetskieZamki extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.priemushestva || []}
        />
        <Cards1
          title={`Каталог детских <span>замков</span>`}
          rtext={``}
          list={data?.cards2?.list || []}
          cols={3}
          margin={`top`}
          layout={5}
          bg={2}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
        />
        <Ruchkibezopasnost
          title={`Безопасная <span>фурнитура</span>`}
          rtext={`[Безопасность и удобство в каждой детали]`}
          list={data?.zamki?.list || []}
          image={data?.zamki?.image}
          btn={false}
          className={`bottom`}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

DetskieZamki.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

DetskieZamki.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default DetskieZamki